module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/library/modules/_add-to-unscopables.js
// module id = 1155
// module chunks = 168707334958949